type Props = {
  className?: string;
  steps: Record<string, string>;
};
export const InstallationSteps = ({steps, className}: Props) => {
  return (
    <div className={className}>
      <ul className="flex flex-col gap-4 text-sm">
        {Object.entries(steps).map(([key, value]) => (
          <li key={key}>
            <span>{key}</span>. <span>{value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
